module.exports = __webpack_public_path__ + "static/img/81102F_2_3_R_20200623_fit.09ab23c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/81102F_2_3_R_20200623_fit.png
// module id = hx8g
// module chunks = 0